
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface NewProviderTypeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const NewProviderTypeModal: React.FC<NewProviderTypeModalProps> = ({ 
  open, 
  onOpenChange 
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Nuevo Tipo de Proveedor</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="nombre">Nombre del tipo</Label>
            <Input 
              id="nombre" 
              placeholder="Ej: Fotografía, Catering, Decoración..." 
            />
          </div>
          <div>
            <Label htmlFor="descripcion">Descripción (opcional)</Label>
            <Textarea 
              id="descripcion" 
              placeholder="Describe qué servicios incluye este tipo..."
              rows={3}
            />
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
              Crear Tipo
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
